import { useAtomValue } from "jotai";
import { icons } from "../assets/icons/icons";
import { useSound } from "../components/SoundHandler";
import { ContainerShape, HexagonShape, InnerShape } from "../components/Shape";
import { atomIsIgamingDemo } from "../states";
import { formatUsdFromEth } from "../utils/demoUsd";

export const ConfirmRaiseModal = ({ currentBet, newBet, onConfirm: _onConfirm, onDismiss }: { currentBet: string, newBet: string, onConfirm: () => void, onDismiss: () => void }) => {
  const sounds = useSound()
  const isIgamingDemo = useAtomValue(atomIsIgamingDemo)

  const onClose = () => {
    onDismiss()
    sounds.play('click')
  };

  const onConfirm = async () => {
    sounds.play('click')
    _onConfirm()
    onDismiss()
  }

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-[#18181B]/50">
      <div>
        <ContainerShape {...{cornerDiagonal: 20, cornerRadius: 8, strokeWidth: 2 }}>
          <div className="p-6 w-[350px] md:w-[448px]">
            <div className="flex flex-row justify-between">
              <div className="mt-1 text-2xl font-blinko font-black text-white">
                Ready to Raise?
              </div>

                <button className="" onClick={onClose}>
                <HexagonShape cornerRadius={6} strokeWidth={1}>
                  <div className="flex justify-center items-center p-2">
                    <img src={icons.close} className='w-6 h-6' />
                  </div>
                </HexagonShape>
              </button>
              
            </div>
            <p className="text-sm text-white/70 mt-3">
              {isIgamingDemo ? (
                <>You’ll go from <span className="text-white">{formatUsdFromEth(currentBet)}</span> to <span className="text-white">{formatUsdFromEth(newBet)}</span>. Proceed?</>
              ) : (
                <>You’ll go from <span className="text-white">{currentBet}</span> ETH to <span className="text-white">{newBet}</span> ETH. Proceed?</>
              )}
            </p>

            <div className="mt-6 flex justify-end space-x-2">
              <button onClick={onConfirm}>
                <InnerShape cornerDiagonal={14} cornerRadius={8} strokeWidth={1}>
                  <div className="relative px-6 py-3">
                    <p 
                      className="text-sm font-blinko text-white"
                    >
                      Raise
                    </p>
                  </div>
                </InnerShape>
              </button>
            </div>
          </div>
        </ContainerShape>
      </div>
    </div>
  );
}
